import React from "react";
import styled from "styled-components";
import Button from "@material-ui/core/Button/Button";
import Close from "@material-ui/icons/Close";
import KeyboardArrowRight from "@material-ui/core/SvgIcon/SvgIcon";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import IconButton from "@material-ui/core/IconButton/IconButton";

import applyImg from "../../../../assests/images/pioneerBenefits.png";
import PioneerNew from "./PioneerNew";

const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 35rem;
  margin-top: 3rem;
  box-shadow: 0 2rem 4rem rgba(0, 0, 0, 0.06);
  border: 1px solid #f4f2f2;
  // shadow: 0 2rem 6rem rgba(0,0,0,.3)

  // shadow: 0 2rem 6rem rgba(0,0,0,.3)
`;

const StyledHeader = styled.div`
  text-transform: uppercase;
  font-weight: 400;
  font-size: 16px;
  padding: 2rem;

  @media (max-width: 800px) {
    font-size: 15px;
  }
`;

const StyledText = styled.div`
  position: absolute;
  right: 0;
  bottom: 0px;
  font-size: 16px;
  font-weight: 300;
  left: 4rem;
  z-index: 90;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 1rem;

  @media (max-width: 700px) {
    font-size: 14px;
  }

  @media (max-width: 325px) {
    left: 2rem;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  position: relative;
  height: auto;
`;

const StyledImage = styled.img`
  width: 100%;
  height: 24rem;
  object-fit: cover;
  object-position: 50% 100%;
`;

const StyledButton = styled(Button)`
  &&& {
    position: relative;
    float: right;
    font-size: 16px;
    color: gray;
    padding-right: 4px;
  }
`;

const BackTitle = styled.h2`
  color: gray;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 20px;
  padding: 2rem;

  @media (max-width: 400px) {
    font-size: 16px;
  }
`;

class Pioneer extends React.Component {
  state = {
    open: false,
    scroll: "paper"
  };

  handleClickOpen = scroll => () => {
    this.setState({ open: true, scroll });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    return (
      <div>
        <StyledCard onClick={this.handleClickOpen("paper")}>
          <StyledHeader>Become a SAMPELL Pioneer</StyledHeader>
          <ImageContainer>
            <StyledImage src={applyImg} alt="Apply as SAMPELL Pioneer" />
            <StyledText>Become Pioneer</StyledText>
          </ImageContainer>
          <div>
            <StyledButton
              aria-label="More"
              variant="text"
              onClick={this.handleClickOpen("paper")}
            >
              More
              <KeyboardArrowRight />
            </StyledButton>
          </div>
        </StyledCard>

        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          scroll={this.state.scroll}
          aria-labelledby="scroll-dialog-title"
          fullwidth={true}
        >
          <BackTitle id="scroll-dialog-title">
            Become a SAMPELL Pioneer
          </BackTitle>
          <DialogContent>
            <DialogContentText>
              <PioneerNew />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <IconButton onClick={this.handleClose} color="gray">
              <Close />
            </IconButton>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default Pioneer;



// WEBPACK FOOTER //
// ./src/components/Pages/Audition/Content/Pioneer.js